import React, { useEffect, useState } from 'react';
import DataService from "../../../services/data.service";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { ItemTypeIdProps } from '../../../types/IdProps';
import AddItemTypeUserDefinedFieldPopup from '../Popups/ItemType_popup_AddUserDefinedField';

const ItemType_tab_UserDefinedFields: React.FC<ItemTypeIdProps> = ({ itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/UserDefinedFields/ByItemType/' + itemTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/UserDefinedFields/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'Id', visible: false },
        { title: 'Name', dataProp: 'name' },
        { title: 'Data type', dataProp: 'dataType' },
        { title: 'Type', dataProp: 'userDefinedFieldType' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemTypeUserDefinedFields'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='User defined field'
                navigateUrl='/plm/ItemSetup/UserDefinedField/'
            />
            {showPopup && <AddItemTypeUserDefinedFieldPopup itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false) }} />}
        </>
    );
}
export default ItemType_tab_UserDefinedFields;